export const sampleInvestorStatistics = (override) => (Object.assign({ pollTagsVoteCount: [
        { tag: { title: 'Audit', id: '4' }, voteCount: 67 },
        { tag: { title: 'Environment', id: '6' }, voteCount: 42 },
        { tag: { title: 'Equality', id: '2' }, voteCount: 8 },
        { tag: { title: 'Lobbying', id: '8' }, voteCount: 2 },
    ] }, override));
